import React, {useState} from 'react'
import PropTypes from 'prop-types'
import {Spin} from "antd"
import BatchesRows from "./BatchesRows"
import BatchRecycle from "../BatchRecycle"

BatchesTable.propTypes = {
    loading: PropTypes.bool,
    batches: PropTypes.array,
    selectedBatchId: PropTypes.array,
    selectedAll: PropTypes.bool,
    onChangeProductType: PropTypes.func.isRequired,
    onSelectAll: PropTypes.func.isRequired,
    onResetSelected: PropTypes.func.isRequired
}

function BatchesTable(props) {
    const {
        loading,
        batches,
        selectedAll,
        selectedBatchId,
        onChangeProductType,
        onUpdateSelectedBatches,
        getBatchesError,
        onResetSelected,
        handleChangeInput,
    } = props

    const [openActions, setOpenActions] = useState(false)

    function _handleChangeCheckbox(e) {
        const {checked} = e.target
        const {onSelectAll} = props

        if (typeof onSelectAll === 'function') {
            onSelectAll(checked)
        }
    }

    function toggleActions() {
        setOpenActions(!openActions)
    }

    return (
        <div className='BatchesTable'>
            <Spin spinning={loading} tip='Đang tải...'>
                <table className='table table-borderless table-striped'>
                    <thead className={`thead-light ${selectedBatchId.length > 0 ? 'Hidden' : ''}`}>
                    <tr>
                        <th className="BatchSelectedAll">
                            <input type="checkbox" checked={selectedAll} onChange={_handleChangeCheckbox}/>
                            {
                                selectedBatchId.length > 0 && <div className="CustomSelect">
                                    <button type="button" className="dropdown-toggle"
                                            onClick={toggleActions}>
                                        Thao tác
                                    </button>
                                    <div className={`ListAction ${openActions ? 'Open' : ''}`}>
                                        <div className="ContentActions">
                                            <BatchRecycle
                                                items={batches}
                                                selectedBatchId={selectedBatchId}
                                                getBatchesError={getBatchesError}
                                                onResetSelected={onResetSelected}
                                            />
                                        </div>
                                    </div>
                                    <div className={`Background ${openActions ? 'Open' : ''}`} onClick={toggleActions}/>
                                </div>
                            }
                        </th>
                        <th className="BatchItem">Item</th>
                        <th className='BatchName'>Tên lô</th>
                        <th className="BatchCreated">Ngày tạo</th>
                        <th className="BatchProductType">Loại sản phẩm</th>
                        <th className="BatchStatus">Trạng thái</th>
                        <th className="BatchPartner">Loại lỗi</th>
                        <th className="BatchPartner">Đối tác in ép</th>
                        {/* <th className="BatchPartner">Đối tác may</th> */}
                        <th className="BatchUserCreated">Người tạo</th>
                        <th className="BatchNote">Ghi chú</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        !!batches && batches.length > 0 ? (
                            batches.map(item => {
                                    return (
                                        <BatchesRows
                                            key={item._id}
                                            item={item}
                                            selectedBatchId={selectedBatchId}
                                            onChangeProductType={onChangeProductType}
                                            onUpdateSelectedBatches={onUpdateSelectedBatches}
                                            handleChangeInput={handleChangeInput}
                                        />
                                    )
                                }
                            )
                        ) : (
                            <tr>
                                <td colSpan={11}>Không có dữ liệu!</td>
                            </tr>
                        )
                    }
                    </tbody>
                </table>
            </Spin>
        </div>
    )
}

export default BatchesTable
